let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g0RMV")).then(() => parcelRequire('cjq2C'));